import React from "react";
import { useAppSelector } from "state/hooks.ts";
import { getDepositFundsModalState } from "state/slices/deposit-funds-modal-v2-slice.ts";
import CommerceButton from "./commerce-button.tsx";
import { ACH_MINIMUM_DEPOSIT } from "utils/constants.ts";

interface DepositButtonProps {
  onDeposit: () => void;
}

const DepositButton = ({ onDeposit }: DepositButtonProps) => {
  const modalState = useAppSelector(getDepositFundsModalState);
  
  const { processing, selectedAmount, selectedPaymentMethod } = modalState;
  
  // Check if minimum amount requirement is met based on payment method
  const isAmountValid = () => {
    if (!selectedAmount) return false;
    
    // For ACH payments, minimum amount is ACH_MINIMUM_DEPOSIT
    if (selectedPaymentMethod?.type === 'ACH') {
      return selectedAmount >= ACH_MINIMUM_DEPOSIT;
    }
    
    // For other payment methods, keep existing validation (amount > 0)
    return selectedAmount > 0;
  };
  
  const disabled = processing || 
    !selectedAmount || 
    !isAmountValid() || 
    !selectedPaymentMethod;

  return (
    <CommerceButton
      onClick={onDeposit}
      disabled={disabled}
      processing={processing}
      actionType="deposit"
      amount={selectedAmount}
    />
  );
};

export default DepositButton; 